import React, { useState, useEffect } from 'react';
import { User as UserType } from '../types';
import TabletLoginScreen from './TabletLoginScreen';
import TabletDashboard from './TabletDashboard';

const TabletInterface: React.FC = () => {
  const [currentUser, setCurrentUser] = useState<UserType | null>(null);
  const [currentView, setCurrentView] = useState<'login' | 'dashboard'>('login');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkTabletUser = async () => {
      const savedUser = localStorage.getItem('tablet-user');
      if (savedUser) {
        try {
          const user = JSON.parse(savedUser);
          setCurrentUser(user);
          setCurrentView('dashboard');
        } catch (error) {
          console.error('Error loading table user:', error);
          setCurrentView('login');
        }
      } else {
        setCurrentView('login');
      }
      setIsLoading(false);
    };

    checkTabletUser();
  }, []);

  const handleLogin = (user: UserType) => {
    if (user.role !== 'table') {
      alert('Acest cont nu are permisiunea de a accesa interfața mesei');
      return;
    }
    
    setCurrentUser(user);
    localStorage.setItem('tablet-user', JSON.stringify(user));
    setCurrentView('dashboard');
  };

  const handleLogout = () => {
    setCurrentUser(null);
    setCurrentView('login');
    localStorage.removeItem('tablet-user');
  };

  if (currentView === 'login') {
    return <TabletLoginScreen onLogin={handleLogin} />;
  }

  if (currentView === 'dashboard' && currentUser) {
    return (
      <TabletDashboard 
        user={currentUser} 
        showAllWorkers={true} 
        onLogout={handleLogout} 
      />
    );
  }

  if (isLoading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Se încarcă...</p>
        </div>
      </div>
    );
  }

  // Fallback - redirect to login if something went wrong
  return <TabletLoginScreen onLogin={handleLogin} />;
};

export default TabletInterface;